import React from 'react';

import Link from '@skippay/core/components/Link';
import Text from '@skippay/core/components/Text';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { REGISTRATION_COMPLETION } from 'constants/routes';

function AuthFooterFinishRegistration() {
	return (
		<Text>
			<span>
				<FormattedMessage
					id="AuthFooterFinishRegistration.uncreatedPassword"
					defaultMessage="Nakoupili jste a chybí vám heslo?"
				/>{' '}
			</span>

			<Link testId="createPassword" to={REGISTRATION_COMPLETION} variant="inherit">
				<FormattedMessage
					id="AuthFooterFinishRegistration.finishRegistration"
					defaultMessage="Vytvořte si ho"
				/>
			</Link>
			<span>.</span>
		</Text>
	);
}

export default AuthFooterFinishRegistration;
